import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';
import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()((theme, { onlyContent } = {}) => ({
  bar: {
    backgroundColor: 'white',
    margin: '0 auto',
    maxWidth: 1180,
    position: 'sticky',
    padding: `40px 26px 12px`,
    top: 50,
    zIndex: 100,
    [theme.breakpoints.down('lg')]: {
      top: pickIf(onlyContent, 0, 40),
    },
    [theme.breakpoints.down('md')]: {
      top: 50,
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)} 12px`,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        top: pickIf(onlyContent, 0, 40),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        top: 50,
        padding: `${theme.spacing(1)} ${theme.spacing(1.5)} 12px`,
      }),
    },
  },
  titleContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(2),
      }),
    },
  },
  title: {
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 22,
      }),
    },
  },
  filtersBox: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('xl')]: {
      gap: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('xl')]: {
      ...(theme.isMobileDevice && {
        gap: theme.spacing(2),
      }),
    },
  },
  button: {
    backgroundColor: '#F4F4F4',
    fontSize: 14,
  },
  search: {
    [theme.breakpoints.down('xl')]: {
      width: 300,
    },
    [theme.breakpoints.downLandscape('xl')]: {
      ...(theme.isMobileDevice && {
        width: 300,
      }),
    },
  },
  mobileBox: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      '& > div:nth-child(1)': {
        order: 1,
      },
      '& > div:nth-child(2)': {
        order: 0,
      },
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        '& > div:nth-child(1)': {
          order: 1,
        },
        '& > div:nth-child(2)': {
          order: 0,
        },
      }),
    },
  },
  searchResult: {
    color: colors.darkGrey,
    fontWeight: 600,
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 14,
        marginTop: theme.spacing(2),
      }),
    },
  },
  noMatches: {
    marginTop: theme.spacing(2),
    fontSize: 18,
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 16,
      }),
    },
  },
}));
